import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import TextField from "@material-ui/core/TextField";
import conf from "config/env.conf.js";
import getDefaultValue from "utils/DefaultValue";
import { useFetch } from "hooks/useFetch";
const ListboxAumphurAreaOpt = props => {
 //  provinceSelected={provinceSelected}
  let optId = props.provinceSelected ? props.provinceSelected.id : 0;
  let isEnable = false;
  let query = "";
  let data = [];
  const [error] = React.useState(false);
  const [helperText] = React.useState("");
  if (props.provinceSelected) {
    query += `/ms/amphures?province_id=${props.provinceSelected.id}`;
   // query += /ms/amphures?province_id={provineId} 
  //  query += `/opt/${props.optSelected.id}/area`;
  }
  
  if (optId > 0) {
    isEnable = true;
  }

  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + `${query}`,
    [props.provinceSelected],
    isEnable
  );

  let content = (
    <TextField
      disabled
      label="เลือกเขตอำเภอ (เฉพาะ อบจ. เท่านั้น)"
      margin="normal"
      fullWidth
    />
  );

  if (
    isEnable &&
    !isLoading &&
    fetchData !== null &&
    fetchData.data !== undefined
  ) {
    data = fetchData.data.map(v => {
      return {
        id: `${v.amphur_id}`,
        value: `${v.amphur_name}`,
      };
    });
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        name="aumphurAreaOPT"
        disabled={props.disabled}
        options={data}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={props.onChange}
        renderInput={params => {
          return (
            <TextField
              {...params}
              error={error}
              helperText={helperText}
              label="เลือกเขตอำเภอ"
              margin="normal"
              fullWidth
            />
          );
        }}
        {...props.customProps}
      />
    );
  }

  return content;
};
export default ListboxAumphurAreaOpt;
